import * as React from 'react';
import { CheckboxField } from '@cian/components';

import { DropdownField, IDropdownValue } from '../../../components/dropdownField';

import { EPublishPeriod } from '../../../../../../../json_query';
import { InlineParam } from '../../../markup';

export interface IPublishPeriodProps {
  publishPeriod: EPublishPeriod;
  onPublishPeriodChange(value: EPublishPeriod): void;

  withPhoto: boolean;
  onWithPhotoChange(value: boolean): void;

  withVideo: boolean;
  onWithVideoChange(value: boolean): void;
}

const PUBLISH_PERIODS: IDropdownValue[] = [
  { value: EPublishPeriod.Any, label: 'За все время' },
  { value: EPublishPeriod.Today, label: 'Сегодня' },
  { value: EPublishPeriod.Hour, label: 'За час' },
  { value: EPublishPeriod.Day, label: 'За сутки' },
  { value: EPublishPeriod.TenDays, label: 'За 10 дней' },
  { value: EPublishPeriod.Month, label: 'За месяц' },
];

export const Publish: React.StatelessComponent<IPublishPeriodProps> = props => (
  <>
    <InlineParam>
      <DropdownField value={props.publishPeriod} onValueChange={props.onPublishPeriodChange} values={PUBLISH_PERIODS} />
    </InlineParam>
    <InlineParam>
      <CheckboxField onValueChange={props.onWithPhotoChange} value={props.withPhoto} label="Фото" />
    </InlineParam>
    <InlineParam>
      <CheckboxField label="Видео" value={props.withVideo} onValueChange={props.onWithVideoChange} />
    </InlineParam>
  </>
);
